import React, { useState, useEffect, useContext, useRef } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import DatePicker from 'react-datepicker';
import { datePopperConfig } from "../Shared/datePopperConfig.js";


let debounceTimer = null;

const AddItemPopup = ({ globalContext }) => {

    const [addTitle, setAddTitle] = useState("");
    const [addDescription, setAddDescription] = useState("");
    const [addAssignedTo, setAddAssignedTo] = useState(window.currentUserId);
    const [addDeadline, setAddDeadline] = useState("");
    const [errorAddTitle, setErrorAddTitle] = useState(false);
    const [errorAddDescription, setErrorAddDescription] = useState(false);
    const [errorAddDeadline, setErrorAddDeadline] = useState(false);
    const [isAddingItem, setIsAddingItem] = useState(false);


    const AppContext = globalContext;

    


    // This method validates if the form field if filled, sets the error message to
    // true for that field and returns false meaning the field is not valid

    const validFormField = (field, errorFunc) => {
        if (field == "") {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };



    const addItem = () => {
        
        let newItem = {
            Title: addTitle,
            Description: addDescription,
            ResponsiblePerson: parseInt(addAssignedTo),
            Deadline: addDeadline != "" ? addDeadline : null,
        };
        

        let isValidForm = true;

        setErrorAddTitle(false);
        setErrorAddDescription(false);
        setErrorAddDeadline(false);


        if (!validFormField(addTitle, setErrorAddTitle))
            isValidForm = false;
        if (!validFormField(addDeadline, setErrorAddDeadline))
            isValidForm = false;
        
        if (!isValidForm) return false;


        let dataUrl = AppContext.dataUrl;

        let requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newItem)
        };


        setIsAddingItem(true);

        fetch(dataUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((item) => {

                let result = [item, ...AppContext.data];

                AppContext.setData(result);
                AppContext.updateListTotalCount();
                AppContext.showAddItemPopup(false);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsAddingItem(false);
            });


    }







    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Add {AppContext.singleItemTitle}</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>



            <div style={{ width: "100%" }}>
                Title
                <br />
                <input className={`form-field-text add-task-field-name ${errorAddTitle ? " form-field-error" : null}`}
                    value={addTitle}
                    onChange={(e) => setAddTitle(e.target.value)}
                    style={{ width: "100%" }} type="text" placeholder="Title *" />

                {errorAddTitle && (
                    <span className="form-field-error-message">
                        This field is necessary
                    </span>
                )}

            </div>


            <br />


            <div style={{ width: "100%" }}>
                Description
                <br />
                <textarea className={`form-field-text add-task-field-name ${errorAddDescription ? " form-field-error" : null}`}
                    value={addDescription}
                    onChange={(e) => setAddDescription(e.target.value)}
                    style={{ width: "100%" }} placeholder="Description" />
            </div>

            <br />

            <div style={{ width: "100%" }}>
                Responsible Person
                <br />
                <select
                    value={addAssignedTo}
                    onChange={(e) => setAddAssignedTo(e.target.value)}
                >
                    {AppContext.users.map((user, index) => (
                        <option key={index} value={user.Id}>
                            {user.Name}
                        </option>
                    ))}
                </select>
            </div>

            <br/>

            <div style={{ width: "100%" }}>
                Deadline / Next Collection (YYYY-MM-DD)
                <br />
                <DatePicker
                    className={`datepicker-field add-task-field-date-start ${errorAddDeadline ? "form-field-error" : null
                        }`}
                    dateFormat="yyyy-MM-dd"
                    selected={addDeadline}
                    onChange={(date) => {
                        setAddDeadline(date);
                    }}
                    popperPlacement={datePopperConfig.placement}
                    popperModifiers={datePopperConfig.modifiers}
                />
                {errorAddDeadline && (
                    <div style={{ width: "100%" }}>
                        <span className="form-field-error-message">
                            This field is necessary
                        </span>
                    </div>
                )}
            </div>

            <br/>





            {/* BUTTONS */}

            <div className="action-button-bar">

                <div className="action-button-bar-left">
                    <button
                        className="action-button cancel-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        Close
                    </button>
                </div>

                <div className="action-button-bar-center">

                </div>

                <div className="action-button-bar-right">
                    {isAddingItem ? (
                        <LoadingSpinnerImage />
                    ) : (
                        <button
                            className="action-button save-button"
                                onClick={addItem}
                        >
                            Add SR Group
                        </button>
                    )}
                </div>
            </div>




        </div>
    );
};








export default AddItemPopup;